module.exports = __webpack_public_path__ + "img/FGr_Führung-Kommunikation_B.2c333e55.svg";